// extracted by mini-css-extract-plugin
export var card = "_pw-0";
export var content = "_pw-2";
export var details = "_pw-3";
export var icon = "_pw-1";
export var iconBlue = "_pw-5";
export var iconBrand = "_pw-4";
export var iconGrayBlue = "_pw-6";
export var iconGreen = "_pw-7";
export var iconIndigo = "_pw-8";
export var iconOrange = "_pw-9";
export var iconPurple = "_pw-a";
export var iconRed = "_pw-b";
export var iconWarning = "_pw-c";